import { useAllShapes } from "http-hooks/shape/useShape";
import DeleteShape from "components/shape/DeleteShape";
import { useState } from "react";
import useModalStore from "store/modals";
import InputSearch from "components/ui/InputSearch";
import Select from "components/ui/Select";
import MasterPage, {
  FilterRow,
  FilterCell,
  ClearFiltersButton,
  AddButton,
  StatusIcon,
  EditAction,
  DeleteAction,
} from "components/ui/MasterPage";

const statusOptions = [
  { value: "", label: "All Status" },
  { value: "1", label: "Active" },
  { value: "0", label: "Inactive" },
];

const initialFilter = {
  shapetype: "",
  ag_status: "",
  page: 1,
  limit: 10,
};

const columns = [
  { key: "shapetype", header: "Shape Type" },
  {
    key: "ag_status",
    header: "Status",
    render: (item) => <StatusIcon value={item.ag_status} />,
  },
  { key: "actions", header: "Actions", isActions: true },
];

export default function ShapeMaster() {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [filter, setFilter] = useState(initialFilter);
  const { openModal } = useModalStore();

  const openSetModal = (id) => openModal("shape", id);

  const handleSearch = (searchTerm) => {
    setFilter((prev) => ({ ...prev, shapetype: searchTerm, page: 1 }));
  };

  const handleStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
    setFilter((prev) => ({
      ...prev,
      ag_status: selectedOption?.value || "",
      page: 1,
    }));
  };

  const clearFilters = () => {
    setSelectedStatus(null);
    setFilter(initialFilter);
  };

  const {
    isLoading,
    data: { data: allshapes, page: currentPage, totalPages } = [],
  } = useAllShapes(filter);

  return (
    <MasterPage
      title="Shapes Master"
      headerActions={
        <AddButton onClick={() => openSetModal()}>Add shape</AddButton>
      }
      filters={
        <FilterRow>
          <FilterCell>
            <InputSearch
              onSearch={handleSearch}
              label="Shape Type"
              placeholder="Search Shape Type"
            />
          </FilterCell>
          <FilterCell>
            <Select
              options={statusOptions}
              value={selectedStatus}
              onChange={handleStatusChange}
              label="Status"
              placeholder="Select status"
              isClearable={true}
              isSearchable={false}
            />
          </FilterCell>
          <ClearFiltersButton onClick={clearFilters} />
        </FilterRow>
      }
      columns={columns}
      data={allshapes}
      isLoading={isLoading}
      rowKey="shapeId"
      deleteComponent={DeleteShape}
      renderActions={(item, setDeleteItemId) => (
        <>
          <EditAction
            onClick={() => openSetModal(item.shapeId)}
            title="Edit Shape"
          />
          <DeleteAction
            onClick={() => setDeleteItemId(item.shapeId)}
            title="Delete Shape"
          />
        </>
      )}
      pagination={{
        currentPage,
        totalPages,
        onPageChange: (page) => setFilter((prev) => ({ ...prev, page })),
      }}
    />
  );
}
